//fieldname
export const FIRSTNAME = "firstName";
export const LASTNAME = "lastName";
export const STATE = "state";
export const COUNTRY = "country";
export const ADDRESS = "address";
export const ZIPCODE = "zipcode";
export const CITY = "city";
export const EMAIL = "email";
export const PHONE = "phone";
export const BONVOYNUMBER = "bonvoyNumber";
export const USA = "United States of America";
export const CANADA = "Canada";